import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Link from '@/components/Link';
import { Link as LinkType } from '@/blocks/components/types';

interface props {
  title: string;
  description: string;
  isMarketingWebsite: boolean;
  contactLink: LinkType;
  googleMaps: string;
}

const Text = ({ children }) => (
  <Typography
    variant='body2'
    component='div'
    sx={{
      color: 'text.secondary',
      maxWidth: {
        xs: '100%',
        sm: 200,
      },
      whiteSpace: 'pre-line',
    }}
  >
    {children}
  </Typography>
);

export default function Links({
  title,
  description,
  isMarketingWebsite,
  contactLink,
  googleMaps,
}: props) {
  const URL_REGEX = /(https?:\/\/)?(www\.)?[\w\-]+\.[\w\-\.]+/i;
  const PHONE_REGEX = /\+?\d[\d\s\-()]{7,}\d/g;
  const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

  const urlMatches = description.match(URL_REGEX);
  const phoneMatches = description.match(PHONE_REGEX);
  const emailMatches = description.match(EMAIL_REGEX);

  return (
    <Grid size={1}>
      <Stack direction='column' spacing={0.75}>
        <Typography
          variant='body1'
          sx={{
            color: 'text.primary',
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
        <Box>
          {urlMatches && phoneMatches && emailMatches ? (
            <>
              {isMarketingWebsite ? (
                <Link href={contactLink?.href || ''} newTab={contactLink?.newTab || false}>
                  {<Text>{contactLink?.text || ''}</Text>}
                </Link>
              ) : (
                <Link href={`https://${urlMatches[0]}`}>{<Text>{urlMatches[0]}</Text>}</Link>
              )}
              <Link href={`tel:${phoneMatches[0]}`}>{<Text>{phoneMatches[0]}</Text>}</Link>
              <Link href={`mailto:${emailMatches[0]}`}>{<Text>{emailMatches[0]}</Text>}</Link>
            </>
          ) : (
            <Link href={googleMaps}>{<Text>{description}</Text>}</Link>
          )}
        </Box>
      </Stack>
    </Grid>
  );
}
